import { useRequest } from 'ahooks';
import _ from 'lodash-es';
import {
  RequrstBack,
  queryInitStatClientConfig,
} from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/hooks';
import http from '@/utils/http';

// Streaming详情页表格
export const usePcTopchartsStreamingRankList = <T, S>(params: T, type: S) => {
  // 表格用到了2个接口，一个用于点击查询展示的列表,一个就是普通的列表接口
  const fetchUrl = {
    defaulet: '/api/v1/intelligence_pc/rank/pc_topcharts_streaming', // 联调新接口，youbin
    // defaulet: '/api/v1/intelligence_pc/pcTopchartsStreamingRankList',
    gameSearchIng: '/api/v1/intelligence_pc/rank/get_game_streaming', // 联调新接口，youbin
    // gameSearchIng: '/api/v1/intelligence_pc/getGameStreaming',
  }[type as string];
  const fetch = (mutateParams: T) =>
    http({
      url: fetchUrl,
      method: 'post',
      data: params,
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    retryCount: 0,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'rankGamesList',
    manual: false,
    loadingDelay: 0,
  });
  return {
    ...data,
  };
};

// Streaming详情页图表
export const usePcTopchartsStreamingTrend = <T, S = string>(params: T, type?: S) => {
  const fetch = (mutateParams: T) =>
    http({
      url: '/api/v1/intelligence_pc/pcTopchartsStreamingTrend',
      method: 'post',
      data: params,
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    retryCount: 0,
    refreshDeps: [params],
    // 当表格数据加载完成后才开始请求，并且card为折线图才开始请求，防止一些用户只是点击表格，对于图表的折线并没有去点，减少请求次数，当然如果点击了，正常会report,图表依赖表格的参数,
    ready: !_.isEmpty(params?.app_ids) && type === 'line' && !!params,
    cacheKey: 'gamesTrend',
    loadingDelay: 500,
  });
  return {
    ...data,
  };
};
